<template>
	<div class="generate-result-page">
		<!-- 导航栏：统一风格 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">生成结果</div>
		</div>

		<!-- 主体区域 -->
		<div class="page-body">
			<!-- 标题模块 -->
			<div class="result-section">
				<!-- 标题+AI改写按钮 两端对齐 -->
				<div class="section-header">
					<div class="section-title">标题</div>
					<div class="ai-rewrite-btn" @click="handleAiRewriteTitle">
						<img src="@/assets/gx.svg" class="rewrite-icon" />
						<span class="rewrite-text">AI改写</span>
					</div>
				</div>
				<!-- 标题输入框 -->
				<textarea class="title-input" v-model="title" placeholder="标题内容"></textarea>
			</div>

			<!-- 内容模块 -->
			<div class="result-section content-section">
				<!-- 内容+AI改写按钮 两端对齐 -->
				<div class="section-header">
					<div class="section-title">内容</div>
					<div class="ai-rewrite-btn" @click="handleAiRewriteContent">
						<img src="@/assets/gx.svg" class="rewrite-icon" />
						<span class="rewrite-text">AI改写</span>
					</div>
				</div>
				<!-- 内容输入框（包含复制按钮） -->
				<div class="content-input-wrapper">
					<textarea class="content-input" v-model="content" placeholder="内容详情"></textarea>
					<!-- 复制文本按钮 -->
					<div class="copy-text-btn" @click="handleCopyText">
						复制文本
					</div>
				</div>
			</div>

			<!-- 下载+转发按钮组 -->
			<div class="action-btn-group">
				<div class="download-btn" @click="handleDownload">
					下载
				</div>
				<div class="forward-btn" @click="handleForward">
					转发
				</div>
			</div>
		</div>
		<div class="vip-tip-mask" v-if="showVipTipModal" @click="closeVipTipModal"></div>
		<div class="vip-tip-modal" v-if="showVipTipModal">
			<div class="vip-tip-title">提示</div>
			<div class="vip-tip-content">下载与转发属于订阅付费功能，付费后可正常使用下载与转发</div>
			<div class="vip-tip-btn-group">
				<button class="vip-tip-btn cancel-btn" @click="closeVipTipModal">返回</button>
				<button class="vip-tip-btn pay-btn" @click="goToPay">去付费</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		checkVip,
		rewrite
	} from "@/api/poster";
	import {
		deviceEnv
	} from '@/utils/device.js';
	const safeDecodeURIComponent = (str) => {
		// 前置校验：非字符串/空值直接返回
		if (typeof str !== 'string' || str.trim() === '') {
			return '';
		}
		// 清理非法的URI编码（比如孤立的%、%后无两位字符）
		const cleanedStr = str.replace(/%(?![0-9A-Fa-f]{2})/g, ''); // 移除孤立的%
		try {
			// 尝试解码，失败则返回清理后的原字符串
			return decodeURIComponent(cleanedStr);
		} catch (e) {
			console.warn('URI解码失败，使用原文本：', e, '原字符串：', str);
			return cleanedStr; // 解码失败时返回清理后的原文本，避免报错
		}
	};
	const safeEncodeURIComponent = (str) => {
		if (typeof str !== 'string' || str.trim() === '') {
			return '';
		}
		try {
			// 先清理非法字符，再编码
			const cleanedStr = str.replace(/[\0\x08\x09\x1a\n\r\\'"%&<>]/g, '_');
			return encodeURIComponent(cleanedStr);
		} catch (e) {
			console.warn('URI编码失败，使用原文本：', e);
			return str;
		}
	};
	export default {
		name: "GenerateResultPage",
		data() {
			return {
				title: "",
				content: "",
				vipType: '',
				showVipTipModal: false,
				isMiniProgram: false,
				currentPlatform: '',
			};
		},
		mounted() {
			this.isMiniProgram = deviceEnv.isWechatMiniProgram;
			// 接收路由传递的参数
			this.initDataFromRoute();
			this.getVip();
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
			document.title = "生成结果";
		},
		methods: {
			async rewriteText(txt) {
				if (!txt) {
					this.$toast('请输入需要改写的文本');
					return;
				}
				try {
					// this.$toast.loading({
					// 	mask: true,
					// 	message: 'AI改写中...'
					// });
					const data = await rewrite({
						content: txt
					});
					// this.$toast.clear();
					// 返回接口返回的改写后数据（需确认接口返回的改写文本字段，若不是直接data则需调整，如data.content）
					return data;
				} catch (error) {
					// this.$toast.clear();
					// console.error("AI改写失败：", error);
					// this.$toast('AI改写失败，请稍后重试');
					return null;
				}
			},
			async getVip() {
				try {
					const data = await checkVip({});
					console.log("数据", data);
					this.vipType = data.vip
				} catch (error) {
					console.error("获取失败：", error);
				}
			},
			closeVipTipModal() {
				this.showVipTipModal = false;
			},

			// 新增：去付费
			goToPay() {
				this.showVipTipModal = false;
				this.$toast('跳转至付费页面...');
				// 示例：window.location.href = '/pages/vip/pay';
			},

			// 修改：下载按钮逻辑（加VIP判断）
			async handleDownload() {
				// 1. VIP校验：非1则弹出提示
				// if (String(this.vipType) !== '1') {
				// 	this.showVipTipModal = true;
				// 	return;
				// }

				// 2. 核心：Canvas 生成白底文字图片（修复 URI 错误 + 兼容双环境）
				const generateTextImage = async () => {
					try {
						// ========== 关键修复1：解码+清理特殊字符，避免DataURL异常 ==========
						const decodeText = (text) => {
							if (!text) return '无内容';
							// 解码URL编码 + 清理URI非法字符（\ / : * ? " < > |）
							let decoded = safeDecodeURIComponent(text);
							return decoded.replace(/\\n/g, '\n').replace(/\\t/g, '  ');
						};
						const title = decodeText(this.title);
						const content = decodeText(this.content);

						// ========== 关键修复2：预计算文字高度（原有逻辑保留，仅优化） ==========
						const tempCanvas = document.createElement('canvas');
						const tempCtx = tempCanvas.getContext('2d');
						const canvasWidth = 750;
						const padding = 40;
						const maxTextWidth = canvasWidth - 2 * padding;
						const titleFontSize = 32;
						const contentFontSize = 24;
						const titleLineHeight = titleFontSize * 1.8;
						const contentLineHeight = contentFontSize * 1.8;
						const titleContentGap = 20;

						// 计算标题高度
						tempCtx.font = `700 ${titleFontSize}px SourceHanSansSC-Bold, sans-serif`;
						const wrapTitle = (text) => {
							const lines = [];
							let currentLine = '';
							for (let char of text) {
								if (tempCtx.measureText(currentLine + char).width > maxTextWidth) {
									lines.push(currentLine);
									currentLine = char;
								} else {
									currentLine += char;
								}
							}
							lines.push(currentLine);
							return lines;
						};
						const titleLines = wrapTitle(title);
						const titleTotalHeight = titleLines.length * titleLineHeight;

						// 计算内容高度
						tempCtx.font = `500 ${contentFontSize}px SourceHanSansSC-Medium, sans-serif`;
						const wrapContent = (text) => {
							const allLines = [];
							const manualLines = text.split('\n');
							manualLines.forEach(manualLine => {
								let currentLine = '';
								for (let char of manualLine) {
									const charWidth = /[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(char) ?
										tempCtx.measureText('aa').width :
										tempCtx.measureText(char).width;
									if (tempCtx.measureText(currentLine).width + charWidth >
										maxTextWidth) {
										allLines.push(currentLine);
										currentLine = char;
									} else {
										currentLine += char;
									}
								}
								allLines.push(currentLine);
							});
							return allLines;
						};
						const contentLines = wrapContent(content);
						const contentTotalHeight = contentLines.length * contentLineHeight;
						const totalHeight = padding + titleTotalHeight + titleContentGap + contentTotalHeight +
							padding;

						// ========== 正式绘制Canvas ==========
						const canvas = document.createElement('canvas');
						const ctx = canvas.getContext('2d');
						canvas.width = canvasWidth;
						canvas.height = totalHeight;

						// 绘制白底背景
						ctx.fillStyle = '#FFFFFF';
						ctx.fillRect(0, 0, canvasWidth, totalHeight);

						// 绘制标题
						let currentY = padding;
						ctx.fillStyle = '#1F2226';
						ctx.font = `700 ${titleFontSize}px SourceHanSansSC-Bold, sans-serif`;
						titleLines.forEach(line => {
							ctx.fillText(line, padding, currentY);
							currentY += titleLineHeight;
						});
						currentY += titleContentGap;

						// 绘制内容
						ctx.fillStyle = '#000000';
						ctx.font = `500 ${contentFontSize}px SourceHanSansSC-Medium, sans-serif`;
						contentLines.forEach(line => {
							ctx.fillText(line, padding, currentY);
							currentY += contentLineHeight;
						});

						// ========== 关键修复3：处理DataURL和文件名，避免URI错误 ==========
						// 生成合法的DataURL（指定编码，避免非法字符）
						const dataURL = canvas.toDataURL('image/png', 1.0);
						if (!dataURL || !dataURL.startsWith('data:image/png;base64,')) {
							throw new Error('生成的图片URL格式非法');
						}

						// 生成合法的下载文件名（转义特殊字符）
						const safeTitle = title.replace(/[\\/:*?"<>|]/g, '_').substring(0, 20); // 截断过长标题
						const fileName = `笔记-${safeTitle || Date.now()}.png`;

						// ========== 关键修复4：双环境兼容的下载逻辑 ==========
						// 优先级1：uni-app 环境（iframe/小程序/APP）→ 用uni原生下载
						// if (typeof uni !== 'undefined' && uni.downloadFile) {
						if (this.isMiniProgram) {
							// 小程序/APP中需先将DataURL转为临时文件（uniapp 原生能力）
							// uni.showLoading({
							// 	title: '图片生成中...'
							// });
							// 步骤1：将base64转为临时文件
							// const base64Data = dataURL.split(',')[1]; // 提取base64部分
							// const tempFilePath = await new Promise((resolve, reject) => {
							// 	// uni-app 原生base64转临时文件（仅APP/小程序支持）
							// 	uni.getFileSystemManager().writeFile({
							// 		filePath: `${wx.env.USER_DATA_PATH}/${fileName}`, // 小程序临时文件路径
							// 		data: base64Data,
							// 		encoding: 'base64',
							// 		success: (res) => resolve(
							// 			`${wx.env.USER_DATA_PATH}/${fileName}`),
							// 		fail: reject
							// 	});
							// });

							// 步骤2：下载临时文件到本地
							wx.miniProgram.navigateTo({
								//拼接url
								url:"/pages/webViewDownFile/index?filetype=img&fileSource=aiText&fileUrl=" + encodeURIComponent(dataURL),
							});
							// window.parent.postMessage({
							// 	type: "BACK_TO_DOMN",
							// 	filetype: 'img',
							// 	fileSource: 'aiText',
							// 	fileUrl: encodeURIComponent(dataURL)
							// 	},
							// 	"*",
							// );
							// uni.downloadFile({
							// 	url: tempFilePath,
							// 	success: (res) => {
							// 		if (res.statusCode === 200) {
							// 			// 保存到相册/本地
							// 			uni.saveImageToPhotosAlbum({
							// 				filePath: res.tempFilePath,
							// 				success: () => {
							// 					this.$toast('图片已保存到相册');
							// 				},
							// 				fail: (err) => {
							// 					console.error('保存图片失败：', err);
							// 					this.$toast('保存图片失败，请开启相册权限');
							// 				}
							// 			});
							// 		}
							// 	},
							// 	fail: (err) => {
							// 		console.error('下载图片失败：', err);
							// 		this.$toast('图片下载失败，请重试');
							// 	},
							// 	complete: () => {
							// 		uni.hideLoading();
							// 	}
							// });
							return;
						}

						// 优先级2：单独浏览器环境 → 用a标签下载（修复URI错误）
						const link = document.createElement('a');
						link.href = dataURL;
						// 对文件名进行URI编码，避免非法字符
						link.download = safeEncodeURIComponent(fileName);
						link.style.display = 'none';
						document.body.appendChild(link);

						// 兼容浏览器触发下载（避免点击失效）
						const clickEvent = new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						});
						link.dispatchEvent(clickEvent);

						// 清理DOM
						setTimeout(() => {
							document.body.removeChild(link);
							// 清理canvas
							tempCanvas.remove();
							canvas.remove();
						}, 100);

						this.$toast('图片生成并开始下载');
					} catch (error) {
						console.error('图片生成/下载失败：', error);
						this.$toast('图片下载失败，请重试');
						// 清理canvas
						try {
							tempCanvas?.remove();
							canvas?.remove();
						} catch (e) {}
					}
				};

				// 执行生成逻辑
				generateTextImage();
			},

			// 修改：转发按钮逻辑（照搬海报页的分享逻辑）
			async handleForward() {
				// VIP校验：非1则弹出提示
				// if (String(this.vipType) !== '1') {
				// 	this.showVipTipModal = true;
				// 	return;
				// }

				// 1. 拼接要分享的内容（标题+内容）
				const shareContent = `${this.title || '无标题'}\n${this.content || '无内容'}`;
				// 若需分享图片，可替换为实际图片URL，这里暂用文本示例
				const currentImageUrl = '';

				// 2. 校验微信小程序环境
				if (this.isMiniProgram) {
					if (typeof wx === 'undefined' || !wx.miniProgram) {
						console.error('微信小程序webview未注入wx对象');
						this.$toast('转发功能暂不可用，请刷新页面重试');
						return;
					}

					try {
						const shareParams = {
							title: this.title || '精美笔记',
							path: `/pages/note/view?content=${safeEncodeURIComponent(shareContent)}`,
							imageUrl: currentImageUrl || ''
						};

						wx.miniProgram.postMessage({
							data: {
								type: 'shareText',
								...shareParams
							}
						});

						wx.miniProgram.navigateTo({
							url: `/pages/note/view?content=${safeEncodeURIComponent(shareContent)}&isShare=1`
						});

						this.$toast('已唤起分享功能，请在小程序中确认');
					} catch (err) {
						console.error('调用小程序转发失败：', err);
						this.$toast('转发功能暂不可用，请稍后重试');
					}
				} else {
					const tip = deviceEnv.isWechatBrowser() ?
						'请在对应小程序中打开以使用转发功能' :
						'转发功能仅支持微信小程序环境';
					this.$toast(tip);
				}
			},
			// 初始化路由参数
			initDataFromRoute() {
				const {
					titles,
					content
				} = this.$route.query;
				if (titles) {
					const titleList = JSON.parse(titles);
					this.title = titleList[0] || "";
				}
				this.content = content || "";
			},
			// 返回按钮
			onBack() {
				this.$router.back();
			},
			// 标题AI改写（空方法）
			async handleAiRewriteTitle() {
				const rewriteResult = await this.rewriteText(this.title);
				if (rewriteResult) {
					this.title = rewriteResult;
					// this.$toast('标题改写成功');
				}
			},
			// 内容AI改写（空方法）
			async handleAiRewriteContent() {
				const rewriteResult = await this.rewriteText(this.content);
				if (rewriteResult) {
					this.content = rewriteResult;
					this.$toast('内容改写成功');
				}
			},

			// 复制文本（空方法）
			handleCopyText() {
				// 1. 拼接标题+内容，中间空一行（处理空值，避免多余空行）
				const titleText = this.title || '';
				const contentText = this.content || '';
				let copyContent = '';

				if (titleText && contentText) {
					copyContent = `${titleText}\n\n${contentText}`; // 标题+空一行+内容
				} else if (titleText) {
					copyContent = titleText; // 只有标题
				} else if (contentText) {
					copyContent = contentText; // 只有内容
				} else {
					this.$toast('暂无可复制的内容');
					return;
				}

				// 2. 兼容浏览器剪贴板API
				if (navigator.clipboard && window.isSecureContext) {
					// 现代浏览器安全上下文
					navigator.clipboard.writeText(copyContent)
						.then(() => {
							this.$toast('标题和内容已复制到剪贴板');
						})
						.catch(err => {
							console.error('剪贴板复制失败：', err);
							this.fallbackCopyTextToClipboard(copyContent); // 传递拼接后的内容到降级方案
						});
				} else {
					// 降级方案（兼容非安全上下文/旧浏览器）
					this.fallbackCopyTextToClipboard(copyContent);
				}
			},

			// 复制降级方案（修改：接收拼接后的内容参数）
			fallbackCopyTextToClipboard(copyContent) {
				const textArea = document.createElement("textarea");
				textArea.value = copyContent; // 使用拼接后的内容
				// 防止滚动到页面外
				textArea.style.position = "fixed";
				textArea.style.top = 0;
				textArea.style.left = 0;
				textArea.style.opacity = 0;
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();
				try {
					const successful = document.execCommand('copy');
					const msg = successful ? '标题和内容已复制到剪贴板' : '复制失败，请手动复制';
					this.$toast(msg);
				} catch (err) {
					console.error('降级复制失败：', err);
					this.$toast('复制失败，请手动复制');
				}
				document.body.removeChild(textArea);
			}
		}
	};
</script>

<style scoped>
	/* 页面基础布局 */
	.generate-result-page {
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}

	/* 导航栏（与原页面完全统一） */
	.custom-nav-bar {
		width: 100%;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 主体区域 */
	.page-body {
		padding: 5.3333vw 4.8vw;
		box-sizing: border-box;
		background: #FFFFFF;
		flex: 1;
		min-height: 0;
		/* 核心：超出屏幕部分纵向滚动 */
		overflow-y: auto;
	}

	/* 结果模块通用样式 */
	.result-section {
		margin-bottom: 4.2667vw;
	}

	/* 标题/内容 头部（两端对齐） */
	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1.6vw;
	}

	/* 标题/内容 文字样式 */
	.section-title {
		opacity: 0.9;
		font-family: SourceHanSansSC-bold;
		color: #1F2226;
		font-weight: 700;
		font-size: 4.2667vw;
		/* 32px = 32/7.5 */
		letter-spacing: -0.1333vw;
		/* -1px = -1/7.5 */
		font-style: normal;
		text-decoration: none;
		text-align: left;
	}

	/* AI改写按钮样式 */
	.ai-rewrite-btn {
		padding: 0.8vw 2.4vw;
		/* 上下6px 左右18px */
		height: 5.3333vw;
		/* 40px = 40/7.5 */
		width: auto;
		display: flex;
		align-items: center;
		gap: 0.8vw;
		/* 图片与文字间距6px */
		border-radius: 2.6667vw;
		opacity: 0.9;
		/* 通用圆角，可根据需求调整 */
		background-color: #1570EE;
		cursor: pointer;
		box-sizing: border-box;
	}

	.rewrite-icon {
		width: 2.6667vw;
		/* 20px 适配高度 */
		height: 2.6667vw;
		object-fit: contain;
	}

	.rewrite-text {
		font-family: SourceHanSansSC-regular;
		color: #FFFFFF;
		font-weight: 400;
		font-size: 2.6667vw;
		/* 20px = 20/7.5 */
		font-style: normal;
		text-decoration: none;
	}

	/* 标题输入框样式 */
	.title-input {
		width: 100%;
		padding: 2.6667vw 3.2vw;
		/* 上下20px 左右24px */
		border-radius: 2.1333vw;
		/* 16px = 16/7.5 */
		border: 0.2667vw solid #D2DAE4;
		/* 2px 边框 */
		box-shadow: 0px -0.2667vw 0px 0px rgba(228, 232, 236, 1);
		/* -2px 阴影 */
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
		outline: none;
		box-sizing: border-box;
		background: #FFFFFF;
		/* 关键修改：允许换行 + 高度自适应 */
		resize: none;
		/* 禁止手动调整大小 */
		min-height: 8vw;
		/* 最小高度适配一行文字（60px） */
		height: auto;
		/* 高度随内容变化 */
		overflow: hidden;
		/* 隐藏滚动条，高度自动撑开 */
		white-space: pre-wrap;
		/* 支持换行 */
		line-height: 1.5;
	}

	/* 内容模块特殊样式 */
	.content-section {
		margin-bottom: 5.3333vw;
		/* 与按钮组间距 */
	}

	.content-input-wrapper {
		position: relative;
		/* 用于复制按钮绝对定位 */
		width: 100%;
	}

	/* 内容输入框样式 */
	.content-input {
		width: 100%;
		/* 关键修改：固定height改为min-height */
		height: 130.5333vw;
		/* 最小高度979px = 979/7.5 ≈ 130.5333vw */
		padding: 2.6667vw 3.2vw;
		padding-bottom: 8vw;
		/* 上下20px 左右24px */
		border-radius: 2.1333vw;
		/* 16px */
		border: 0.2667vw solid #D2DAE4;
		/* 2px 边框 */
		box-shadow: 0px -0.2667vw 0px 0px rgba(228, 232, 236, 1);
		/* -2px 阴影 */
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
		outline: none;
		resize: none;
		/* 禁止手动调整大小 */
		box-sizing: border-box;
		background: #FFFFFF;
		line-height: 1.5;
		/* 关键：内容超出时高度自动增加 */
		overflow-y: auto;
		overflow-x: hidden;
		/* 3. 移除导致高度自适应的配置（height: auto/overflow: hidden） */
		/* 补充：优化移动端滚动体验 */
		-webkit-overflow-scrolling: touch;
	}

	/* 复制文本按钮样式 */
	.copy-text-btn {
		position: absolute;
		bottom: 2.6667vw;
		/* 紧贴下padding */
		right: 3.2vw;
		/* 紧贴右padding */
		padding: 0.8vw 2.6667vw;
		/* 上下6px 左右20px */
		height: 5.3333vw;
		/* 40px */
		border-radius: 2.6667vw;
		/* 20px = 20/7.5 */
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		/* 2px 边框 */
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		/* 20px */
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		/* 垂直居中 */
		display: flex;
		align-items: flex-end;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}

	/* 下载+转发按钮组 */
	.action-btn-group {
		margin-top: 5.3333vw;
		/* 距离上方40px */
		display: flex;
		justify-content: center;
		gap: 3.2vw;
		/* 按钮间距24px = 24/7.5 */
	}

	/* 下载按钮样式 */
	.download-btn {
		width: 29.3333vw;
		/* 220px = 220/7.5 */
		height: 8vw;
		/* 60px = 60/7.5 */
		border-radius: 2.1333vw;
		/* 16px */
		background-color: #EBEBED;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
		/* 文字样式 */
		opacity: 0.8;
		font-family: SourceHanSansSC-medium;
		color: #666666;
		font-weight: 500;
		font-size: 3.2vw;
		/* 24px = 24/7.5 */
		font-style: normal;
		text-decoration: none;
	}

	/* 转发按钮样式 */
	.forward-btn {
		width: 29.3333vw;
		/* 220px */
		height: 8vw;
		/* 60px */
		border-radius: 2.1333vw;
		/* 16px */
		background: linear-gradient(148.76deg, rgba(47, 255, 181, 1) 0%, rgba(30, 137, 255, 1) 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
		/* 文字样式 */
		font-family: SourceHanSansSC-medium;
		color: #FFFFFF;
		font-weight: 500;
		font-size: 3.2vw;
		/* 24px */
		font-style: normal;
		text-decoration: none;
	}

	.vip-tip-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 99999;
	}

	/* 新增：提示框主体（750px设计稿适配） */
	.vip-tip-modal {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 80vw;
		/* 600px/7.5 */
		height: 48vw;
		/* 360px/7.5 */
		background-color: #ffffff;
		border-radius: 3.2vw;
		/* 24px/7.5 */
		z-index: 100000;
		box-sizing: border-box;
		padding: 0;
	}

	/* 新增：提示标题 */
	.vip-tip-title {
		margin-top: 5.333vw;
		/* 40px/7.5 */
		font-size: 4.267vw;
		/* 32px/7.5 */
		color: #1F2226;
		font-weight: 500;
		text-align: center;
	}

	/* 新增：提示文案 */
	.vip-tip-content {
		margin-top: 4.267vw;
		/* 32px/7.5 */
		margin-left: 6.4vw;
		/* 48px/7.5 */
		margin-right: 6.4vw;
		/* 48px/7.5 */
		height: 9.6vw;
		/* 72px/7.5 - 固定高度 */
		font-size: 3.2vw;
		/* 24px/7.5 */
		color: #1F2226;
		font-weight: 400;
		word-break: break-word;
		overflow: hidden;
		box-sizing: border-box;
		line-height: normal;
		padding: 0;
		text-align: center;
	}

	/* 新增：按钮组 */
	.vip-tip-btn-group {
		display: flex;
		justify-content: space-between;
		margin-top: 5.333vw;
		/* 40px/7.5 */
		margin-left: 6.4vw;
		/* 48px/7.5 */
		margin-right: 6.4vw;
		/* 48px/7.5 */
	}

	/* 新增：按钮通用样式 */
	.vip-tip-btn {
		width: 32vw;
		/* 240px/7.5 */
		height: 11.867vw;
		/* 89px/7.5 */
		border-radius: 2.133vw;
		/* 16px/7.5 */
		border: none;
		font-size: 3.733vw;
		/* 28px/7.5 */
		font-weight: 500;
		cursor: pointer;
		line-height: 1;
	}

	/* 新增：左侧返回按钮 */
	.cancel-btn {
		background-color: #F6F6F6;
		color: #1F2226;
	}

	/* 新增：右侧去付费按钮（渐变背景） */
	.pay-btn {
		background: linear-gradient(121deg, #2FFFB5 0%, #1E89FF 100%);
		color: #FFFFFF;
	}
</style>